import React, { PureComponent, Fragment } from "react";
import classnames from "classnames";
import "react-day-picker/lib/style.css";
import DayPicker from "react-day-picker";
import MomentLocaleUtils from "react-day-picker/moment";
// For languages
import "moment/locale/fr";
import "moment/locale/nl";

import _ from "i18n";
import { MONTHS, DAYS_CALENDAR } from "Config";

import collaboratorApi from "../../services/CollaboratorServices";

import styles from "./CollaboratorSpace.local.scss";

import { CollaboratorSpaceAddToCalendar } from "./CollaboratorSpaceAddToCalendar";

class CollaboratorCalendar extends PureComponent {
  //******************   Content Functions  **************//

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      error: false,
      locale: "ar",
      modifiers: [],
      tags: [],
      selectedTags: [],
      month: new Date().getMonth(),
      yearCalendar: new Date().getFullYear(),
      selectedPresentation: "my"
    };

    this.onNextClick = this.onNextClick.bind(this);
    this.onPrevClick = this.onPrevClick.bind(this);
  }

  componentDidMount() {
    const { year } = this.props;
    this.fetchCollaboratorCalendarDates(year);
  }

  componentDidUpdate(prevProps, prevState) {
    const { year } = this.props;
    const { selectedPresentation } = this.state;
    if (
      prevProps.year !== year ||
      prevState.selectedPresentation !== selectedPresentation
    ) {
      this.fetchCollaboratorCalendarDates(year);
    }
  }

  fetchCollaboratorCalendarDates = year => {
    const { user, organization } = this.props;
    const { selectedPresentation } = this.state;
    this.setState({ loading: true });

    collaboratorApi
      .getCollaboratorAllPresentations(organization.uen, user.id)
      .then(response => {
        let appointements = [];
        let tags = [];
        if (selectedPresentation === "my") {
          response.data.data.presentations.forEach(presentation => {
            if (presentation.date) {
              appointements.push(new Date(presentation.date));
              tags.push({ ...presentation, date: new Date(presentation.date) });
            }
          });
        } else {
          response.data.data.presentationsGd.forEach(presentation => {
            if (presentation.date) {
              appointements.push(new Date(presentation.date));
              tags.push({ ...presentation, date: new Date(presentation.date) });
            }
          });
        }
        this.setState({
          modifiers: appointements,
          tags: tags,
          loading: false
        });
        this.filterTagsByMonth(this.state.month);
      })
      .catch(error => {
        this.setState({ error: true, loading: false });
      });
  };

  onNextClick() {
    if (this.state.month < 11) {
      this.setState({ month: this.state.month + 1 });
      this.filterTagsByMonth(this.state.month + 1);
    }
    if (this.state.month === 11) {
      this.setState({ month: 0 });
      this.setState({ yearCalendar: this.state.yearCalendar + 1 });
      this.filterTagsByYear(this.state.yearCalendar + 1);
    }
  }

  onPrevClick() {
    if (this.state.month > 0) {
      this.setState({ month: this.state.month - 1 });
      this.filterTagsByMonth(this.state.month - 1);
    }
    if (this.state.month === 0) {
      this.setState({ month: 11 });
      this.setState({ yearCalendar: this.state.yearCalendar - 1 });
      this.filterTagsByYear(this.state.yearCalendar - 1);
    }
  }

  filterTagsByMonth = month => {
    let { tags } = this.state;
    let selectedTags = tags
      .filter(tag => tag.date.getMonth() === month)
      .sort(function(a, b) {
        return a.date.getTime() - b.date.getTime();
      });

    this.setState({
      selectedTags: selectedTags
    });
  };

  filterTagsByYear = yearCalendar => {
    let { tags } = this.state;
    let selectedTags = tags
      .filter(tag => tag.date.getFullYear() === yearCalendar)
      .sort(function(a, b) {
        return a.date.getTime() - b.date.getTime();
      });

    this.setState({
      selectedTags: selectedTags
    });
  };
  handleSelectPresentationFilter = index => {
    this.setState({
      selectedPresentation: index
    });
  };

  // *****************   RENDERING  ***********************

  renderMonthsTags = () => {
    const { selectedTags } = this.state;
    let tagsRendering = [];
    selectedTags.forEach((item, i) => {
      tagsRendering.push(
        this.state.yearCalendar == item.date.getFullYear() &&
          this.state.month == item.date.getMonth() && (
            <div
              className={classnames(styles.tag, styles.appointment)}
              key={"month_tag_" + i}
            >
              <span className={classnames(styles.tag_color)} />

              <span className={styles.tag_label}>
                {`${_("presentation")} ${item.clientName} ${item.period}`} :{" "}
                <b>
                  {DAYS_CALENDAR.map(
                    (it, index) =>
                      item.date.toString().split(" ")[0] == it.value
                        ? _(it.label)
                        : ""
                  )}
                  &nbsp; {item.date.getDate()}
                </b>
              </span>
            </div>
          )
      );
    });
    return (
      <div className={styles.tag_month} key={MONTHS[this.state.month]}>
        {tagsRendering}
      </div>
    );
  };

  renderCollaboratorCalendarHeader = () => {
    const { tags, loading } = this.state;
    return (
      <Fragment>
        <div className={styles.entete} style={{ margin: "10px 0px 20px" }}>
          <h3 className={styles.title}>{_("rendezVous")}</h3>
          {loading ? (
            <div
              className={classnames(
                styles.add_to_calendar_fetching,
                styles.gradiant
              )}
            />
          ) : (
            <CollaboratorSpaceAddToCalendar
              events={tags}
              isMulti={tags.length > 1}
            />
          )}
          {/*/!*<div className={styles.explore_button}>{_("explore")}</div>*!/*/}
        </div>
        <div className={styles.entete}>
          <div
            className={classnames(styles.leftButton, styles.explore_button)}
            onClick={this.onPrevClick}
          >
            <img
              className={styles.left}
              alt={""}
              src={
                "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAwCAYAAAB5R9gVAAAABGdBTUEAALGPC/xhBQAAAVVJREFUWAnN2G0KgjAYwPHpGfRkaZeqvgQaK+hY3SUHrk1YzNLay/OiEFp92I+/Mp2F2Mh2lLISWnflFjzH263RQjzMZ19wgs73ez0o1WmtW+dgA01VxrE3p6l2GLsnBy1VYQOtVSEH/atCCgqpQgKKqYIOiq2CBkqtggLKqQIKgqgCBjpJ2Y5CdJ+zrT9A7HHSTA1dxUdHgzCqJIEwq0SDsKsEg6iqBIEoq/wEcVRZBXFV+QJxV5mBtlDFB5VjYTaGZ2sf4R9PM7U9ZU+lLuaetPP/5Die3ToO1+u+MKtHs06qODB2zBnI/jBd4MPQm1VkY79Tb18gB+C62FdBFsZR6yeIo1YQiLJWMIiqVjQIu1YSCLNWFgijVjYIuhYYCKoWKAiiFgoopxYaKLUWOii2FgkophYp6F3r42W5A9s9OcgNvva8xQaysKXlFytoqdYmQH6tF3toSUo0INq9AAAAAElFTkSuQmCC"
              }
            />
          </div>
          <div
            className={classnames(styles.rightButton, styles.explore_button)}
            onClick={this.onNextClick}
          >
            <img
              className={styles.right}
              alt={""}
              src={
                "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAwCAYAAAB5R9gVAAAABGdBTUEAALGPC/xhBQAAAXRJREFUWAnN119ugjAcwPHWzJ1gnmxzB/BBE0n24m4xfNkTaOL7wOtsl3AXMMb+Vjaa1BG00N8fSEibPpAP3xAKKs2yjzTPH9RAjhEo9WzPr/Vm8zgE0+gXATAxxuxtqeJ9t5tIwv5AtQAApsfT6TPdbp+kUBcgVwvO51KqVhMkXKsVJFXrOkigVhCIs1Y4iKlWZxB1rX4gwlpRIIpa8SDkWmggrFq4IIRaJKCYWnSgnrXIQV1r8YD+1Vrn+bReagysIFfLABRt31v8oBu1xEBttfRbltmfjgEcWh9snUS2kNdBK6WN1vrOWxObWsz+fjxevsxmB1GQDfINWiev83nhaoiB/CoOU438oPrhXS0WpQ9xc1ZQWxWHqUYe0I0qrKCQKjygDlXIQV2r0IF6ViEBxVTBBSFUQQNhVYkHIVeJAtkNsbQ7c1LtzP6FsObhb2rCKv7NBIGoq4SDmKoEgTirXAcJVGkFSVVpgoSrXICGUMUH/QBZNSUy5XWUhwAAAABJRU5ErkJggg=="
              }
            />
          </div>
        </div>
      </Fragment>
    );
  };

  renderCalendarSection = () => {
    const { locale, modifiers, selectedPresentation } = this.state;
    let allModifiers = {
      weekend: { daysOfWeek: [0, 6] },
      appointment: modifiers
    };
    return (
      <Fragment>
        <DayPicker
          className={classnames(
            "calendar",
            "collaboratorDayPicker",
            "MonthCollab"
          )}
          localeUtils={MomentLocaleUtils}
          locale={locale}
          month={new Date(this.state.yearCalendar, this.state.month)}
          modifiers={allModifiers}
          fixedWeeks
        />
        <div className={styles.tabs}>
          <div
            className={
              styles.tab_badge +
              " " +
              (selectedPresentation === "my" ? styles.tab_badge_active : "")
            }
            onClick={() => this.handleSelectPresentationFilter("my")}
          >
            <span className={styles.span_label}>{_("myPresentations")}</span>
          </div>
          <div
            className={
              styles.tab_badge +
              " " +
              (selectedPresentation === "gd" ? styles.tab_badge_active : "")
            }
            onClick={() => this.handleSelectPresentationFilter("gd")}
          >
            <span className={styles.span_label}>{_("myFolders")}</span>
          </div>
        </div>
        <div className={styles.footer}>
          <div className={styles.tags_container}>{this.renderMonthsTags()}</div>
        </div>
      </Fragment>
    );
  };

  renderCalendarSectionFeatching = () => {
    let month = [];
    let tags = [];
    for (let j = 0; j < 6; j++) {
      let week = [];
      for (let i = 0; i < 7; i++) {
        week.push(
          <div
            key={`${j}-${i}`}
            className={classnames(styles.day, styles.gradiant)}
          />
        );
      }
      month.push(
        <div key={j} className={styles.row_fetching}>
          {week}
        </div>
      );
    }
    for (let i = 0; i < 2; i++) {
      tags.push(<div key={`tag-${i}`} className={styles.gradiant} />);
    }
    return (
      <div className={styles.calendar_section_fetching}>
        <div className={styles.calendar_fetching}>{month}</div>
        <div className={styles.tags_fetching}>{tags}</div>
      </div>
    );
  };

  render() {
    let { loading } = this.state;
    return (
      <div className={styles.lower_section}>
        <div className={styles.calendar_section}>
          {this.renderCollaboratorCalendarHeader()}
          {loading
            ? this.renderCalendarSectionFeatching()
            : this.renderCalendarSection()}
        </div>
      </div>
    );
  }
}

export default CollaboratorCalendar;



// WEBPACK FOOTER //
// ./src/components/CollaboratorSpace/CollaboratorSpaceCalendar.js